module.exports = __webpack_public_path__ + "static/media/styleGuide.8d4cb819.gif";